import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { ReservationsService } from 'src/app/services/triggers/reservations.service';
import { GlobalService } from 'src/app/services/global.service';
import { VehicleService } from 'src/app/services/vehicle.service';

@Component({
  selector: 'app-car-status',
  templateUrl: './car-status.component.html',
  styleUrls: ['./car-status.component.css']
})
export class CarStatusComponent implements OnInit {
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl()
  });
  
  activeReservations: any[] = [];
  displayedColumns = ["id", "user_full_name", "start_time", "end_time"];
  reservationIds: number[] = [];
  currentCarStatus: number = 0;
  isJourney: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CarStatusComponent>,
    private reservationService: ReservationsService,
    private globalService: GlobalService,
    private vehicleService: VehicleService
  ) { }

  ngOnInit(): void {
    // Get the current status of the car
    this.vehicleService.getVehicle(this.data.vehicleId).subscribe({
      next: (result: any) => {
        if (result.success && result.data) {
          console.log(result.data.status);
          this.currentCarStatus = result.data.status?.status_type || 0;
          this.isJourney = this.currentCarStatus === 11;
          
          // Only load reservations if current status is not Journey and the new status is not Open or Journey
          if (!this.isJourney && this.data.name !== 'Open' && this.data.name !== 'Journey') {
            this.loadActiveReservations();
            
            // Subscribe to start date changes to clear end date when start is cleared
            this.range.get('start')?.valueChanges.subscribe(startDate => {
              if (!startDate) {
                this.range.get('end')?.setValue(null);
              }
            });

            // Subscribe to date changes
            this.range.valueChanges.subscribe(dates => {
              // Call loadActiveReservations for both setting and clearing dates
              this.loadActiveReservations(dates);
            });
          }
        }
      },
      error: this.globalService.handleError
    });
  }

  closeDialog() {
    const dateRange = {
      start: this.range.value.start && moment(this.range.value.start).isValid() ? 
        moment(this.range.value.start).format('YYYY-MM-DDT00:00') : null,
      end: this.range.value.end && moment(this.range.value.end).isValid() ? 
        moment(this.range.value.end).format('YYYY-MM-DDT23:59') : null
    };

    this.dialogRef.close({
      dateRange: dateRange,
      reservationIds: this.reservationIds
    });
  }

  loadActiveReservations(dates?: any) {
    let start_date = null;
    let end_date = null;

    // Only format valid dates - use YYYY-MM-DD format for API calls
    if (dates?.start && moment(dates.start).isValid()) {
      start_date = moment(dates.start).format('YYYY-MM-DD');
    }
    if (dates?.end && moment(dates.end).isValid()) {
      end_date = moment(dates.end).format('YYYY-MM-DD');
    }
    
    let url = `${this.data.vehicleId}`;
    const params = [];
    
    if (start_date) {
      params.push(`start_date=${start_date}`);
    }
    if (end_date) {
      params.push(`end_date=${end_date}`);
    }
    
    if (params.length > 0) {
      url += '?' + params.join('&');
    }

    this.reservationService.getActiveReservationsForVehicle(url)
      .subscribe({
        next: (result: any) => {
          this.activeReservations = result.data;
          this.reservationIds = this.activeReservations.map(res => res.id);
        },
        error: this.globalService.handleError
      });
  }
}
